export enum CalendarObjectType
{
    all = "a",
    calendar = "c",
    calendarGroup = "g" 
}